module.exports = __webpack_public_path__ + "img/home-comment-bg-2022.ecbecd86.png";